// JS file for PortfolioList

import '@main';

u.$ui.bootstrap.tooltip();

// List
const listContainer = u.selectOne('#portfolio-items');
const loadMorePlaceholder = u.selectOne('[data-role="loadmore-placeholder"]');
let loading = false;
let page = 1;
let stop = false;
const url = new URL(location.href);

loadItems(page);

window.addEventListener('scroll', handleInfiniteScroll);

// @see https://webdesign.tutsplus.com/tutorials/how-to-implement-infinite-scrolling-with-javascript--cms-37055
async function handleInfiniteScroll() {
  const rect = loadMorePlaceholder.getBoundingClientRect();
  const offset = 300;

  const endOfPage = (rect.y - window.innerHeight - offset) < 0;

  if (endOfPage && !loading && !stop) {
    await loadItems();

    setTimeout(() => {
      rellax.refresh();
    }, 1000);
  }
}

async function loadItems() {
  loading = true;
  const res = await u.$http.get(
    `@portfolio_ajax/items?page=${page}`,
    {
      params: {
        tag: url.searchParams.get('tag'),
        q: url.searchParams.get('q'),
      }
    }
  );

  page++;

  const { html, maxPage } = res.data.data;

  $(listContainer).append(html);

  loading = false;

  stop = maxPage < page;
}

// Item
// class PortfolioItem {
//   constructor(el) {
//     // el.addEventListener('click', () => {
//     //
//     // });
//   }
// }
//
// u.directive(
//   'portfolio-link',
//   {
//     mounted(el, { value }) {
//       u.module(el, 'portfolio.item', () => new PortfolioItem(el));
//     }
//   }
// )
